import { Body, Head, Html, Img, Link, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { Helpers } from "utils";
import { IPotluck } from "interfaces";

// components
import { Footer, Footnote, Schedule } from "./components";

export type Props = {
  url: string;
  name: string;
  potluck: IPotluck;
};

export const Invitation = ({
  url,
  name,
  potluck: { party_name, date, start_time, end_time },
}: Props) => {
  return (
    <Html lang="en">
      <Head />
      <Body style={Styles.body}>
        <Img
          style={Styles.img}
          src={Helpers.getImage("email_invitation.png")}
        />
        <div style={Styles.content}>
          {/* header */}
          <Text style={Styles.textBold}>
            {name} has invited you to contribute and vote in her upcoming
            Potluck! Share the dishes you're planning to bring, explore others'
            suggestions, and vote for your favourites—the potluck party is in
            your hands!",
          </Text>

          {/* potluck */}
          <Text style={Styles.text}>{party_name}</Text>

          {/* schedule */}
          <Schedule date={date} startTime={start_time} endTime={end_time} />

          {/* paragraph */}
          <Text style={Styles.text}>
            You are invited to contribute to our potluck party, that's happening
            on{" "}
            <Text style={{ ...Styles.textBold, display: "inline" }}>
              {date} {start_time && ", " + start_time}{" "}
              {start_time && end_time && "—" + end_time}
            </Text>
          </Text>

          {/* paragraph */}
          <Text style={Styles.text}>
            Make a wish list and vote your favourite dishes so that everyone
            gets to enjoy what they would like!
          </Text>

          {/* button */}
          <Link href={url} style={Styles.button}>
            Start My Wish List
          </Link>

          {/* footnote */}
          <Footnote />
        </div>
        <Footer />
      </Body>
    </Html>
  );
};
